import { AbstractControl, FormGroup } from '@angular/forms';
import { Constants } from 'src/app/core/constants';

export function ValidateProposalOverrideFields(g: FormGroup, formErrors: any, checkDirty?: boolean, checkOnlyRequired: boolean = false) {

  ValidateForNumberRequiredMinValue(g, formErrors, 'Length', Constants.DimensionsMinLength_Shippable);
  ValidateForNumberRequiredMinValue(g, formErrors, 'Width', Constants.DimesionsMinWidth_Shippable);
  ValidateForNumberRequiredMinValue(g, formErrors, 'Height', Constants.DimensionsMinHeight_Shippable);
  ValidateForNumberRequiredMinValue(g, formErrors, 'Weight', 0);
  ValidateForNumberRequiredMinValue(g, formErrors, 'PrimaryTareWeight',  0);
  ValidateForNumberRequiredMinValue(g, formErrors, 'SecondaryTareWeight',  0);
  ValidateForNumberRequiredMinValue(g, formErrors, 'SecondaryNoOfLayers', 0);
  ValidateForNumberRequiredMinValue(g, formErrors, 'SecondaryContainersPerLayer', 0);
  ValidateForNumberRequiredMinValue(g, formErrors, 'TertiaryTareWeight',  0);
  ValidateForNumberRequiredMinValue(g, formErrors, 'TertiaryNoOfLayers', 0);
  ValidateForNumberRequiredMinValue(g, formErrors, 'TertiaryContainersPerLayer', 0);
  ValidateForNumberRequiredMinValue(g, formErrors, 'QPC', 1);
  // ValidateForStringRequiredMinMaxLength(g, formErrors, 'DunnageType', 1, 255);
  ValidateDunnageTypes(g, formErrors, checkDirty);
  return formErrors;
}

function ValidateDunnageTypes(g: FormGroup, formErrors: any, checkDirty?: boolean) {
  const primaryDunnageType = g.get('PrimaryDunnageType').value;
  const secondaryDunnageType = g.get('SecondaryDunnageType').value;
  if (primaryDunnageType) {
    ValidateForStringRequiredMinMaxLength(g, formErrors, 'PrimaryDunnageType', 0, 10);
  }
  if (secondaryDunnageType) {
  ValidateForStringRequiredMinMaxLength(g, formErrors, 'SecondaryDunnageType', 0, 10);
  }
  return formErrors;
}

function ValidateForNumberRequiredMinValue(g: FormGroup, formErrors: any, fieldName: string, minValue: Number) {
  const fieldValue = g.get(fieldName).value;

  if (fieldValue == null || isNaN(fieldValue)) {
    // In override form, all fields are optional so just return if blank/null
    return;
  } else if (fieldValue <= minValue) {
    g.controls[fieldName].setErrors({'min': true});
    formErrors[fieldName] = 'Value should be greater than ' + minValue;
  } else {
    return;
  }
}

function ValidateForStringRequiredMinMaxLength(g: FormGroup, formErrors: any, fieldName: string, minLength: Number, maxLength: Number) {
  const fieldValue = g.get(fieldName).value;
  if (fieldName == 'PrimaryDunnageType' || fieldName == 'SecondaryDunnageType') {
    if (isNaN(fieldValue) || fieldValue.length > 0) {
       return;
    }
  }
  if (isEmptyOrSpaces(fieldValue) || fieldValue.length < minLength) {
    g.controls[fieldName].setErrors({'required': true});
   formErrors[fieldName] =  'This field is required';
  } else if (fieldValue.length > maxLength) {
    g.controls[fieldName].setErrors({'max': true});
    formErrors[fieldName] = 'Maximum number of characters=' + maxLength;
  } else {
    return;
  }
}

function isEmptyOrSpaces(str: string) {
  return str === null || str.match(/^ *$/) !== null;
}

function isNAN(value: any) {
  return Number.isNaN(value as any);
}